import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeCtx = createContext(null);
const STORAGE_KEY = "ls_theme";

const getInitial = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === "light" || stored === "dark") return stored;
    } catch { /* ignore */ }
    if (typeof window !== "undefined" && window.matchMedia) {
        return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
    }
    return "dark";
};

const apply = (t) => {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("data-theme", t);
    const themeColor = t === "light" ? "#FAF7F2" : "#0A0A0A";
    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
        meta = document.createElement("meta");
        meta.name = "theme-color";
        document.head.appendChild(meta);
    }
    meta.content = themeColor;
};

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => getInitial());

    useEffect(() => {
        apply(theme);
        try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* ignore */ }
    }, [theme]);

    const toggle = useCallback(() => setTheme((t) => (t === "light" ? "dark" : "light")), []);

    return (
        <ThemeCtx.Provider value={{ theme, setTheme, toggle }}>
            {children}
        </ThemeCtx.Provider>
    );
};

export const useTheme = () => useContext(ThemeCtx) || { theme: "dark", toggle: () => {} };
